import { newTreeNodeList } from "../TreeNodeMakers";
/**
 * TreeNodeAncestry class.
 */
export class TreeNodeAncestry {
    parentTreeNode;
    /**
     * Constructor.
     *
     * @param  {TreeNode} parentTreeNode The parent TreeNode.
     */
    constructor(parentTreeNode) {
        this.parentTreeNode = parentTreeNode;
    }
    /**
     * Get a nodes ancestory. First element is most distant ancestor (greatest
     * grandparent), and last is this node itself.
     *
     * @param  {TreeNodeList}  mols  The list of molecules to search.
     * @returns {TreeNodeList}  The list of nodes in the ancestory.
     */
    getAncestry(mols) {
        // If you get here, node is of type TreeNode.
        let curNode = this.parentTreeNode;
        const ancestors = newTreeNodeList([this.parentTreeNode]);
        while (curNode.parentId) {
            const parentNode = mols.filters.onlyId(curNode.parentId);
            if (parentNode === null) {
                break;
            }
            // Add at first position
            ancestors.unshift(parentNode);
            curNode = parentNode;
        }
        return ancestors;
    }
}
